import { LOCALE_ID, NgModule } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF, DatePipe, registerLocaleData } from '@angular/common';

import { RsmLoaderModule } from '@rsm/shared/loader';
import { RsmMessageModule } from '@rsm/shared/message';
import { RsmSecurityModule } from '@rsm/shared/security';
import { ErrorInterceptor } from '@rsm/shared/error';
import { AuthClientModule } from '@rsm/client/auth-client';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NgxDropzoneModule } from 'ngx-dropzone';
import { MissionClientModule } from '@rsm/client/mission-client';
import { AgenteClientModule } from '@rsm/client/agente-client';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxMaskModule } from 'ngx-mask';
import { MatTabsModule } from '@angular/material/tabs';
import { CompanySetupModule } from './pages/company-setup/company-setup.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPtBrPaginatorIntl } from '@rsm/shared/helpers/pageTranslator';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { TopbarComponent } from './layouts/main/components/topbar/topbar.component';
import { StatusChipComponent } from './components/status-chip/status-chip.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent, PageHeaderComponent, TopbarComponent, StatusChipComponent],
  imports: [
    MatTabsModule,
    QRCodeModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AuthClientModule,
    MissionClientModule,
    AgenteClientModule,
    BrowserAnimationsModule,
    RsmLoaderModule.forRoot(),
    RsmMessageModule.forRoot(),
    FontAwesomeModule,
    NgxMaskModule.forRoot(),
    NgxDropzoneModule,
    CompanySetupModule,
    RsmSecurityModule.forRoot({
      rootRoute: '/',
      contextRoute: '/access/context',
      loginRoute: '/access/login',
      passwordRoute: '/expired-password',
      storage: 'rsm_mission_storage',
    }),
    CompanySetupModule,
  ],
  providers: [
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useValue: getPtBrPaginatorIntl() },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
